/* tslint:disable */
/* eslint-disable */
/**
 * Easy Invoices API v1
 * The Easy Invoices API for Shopify embedded app - automatic invoice generation and export functionality
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateCannedResponseDto
 */
export interface UpdateCannedResponseDto {
    /**
     * Why the operator is doing this. Stored verbatim in OperatorAuditLog.reason.
     * @type {string}
     * @memberof UpdateCannedResponseDto
     */
    'reason': string;
    /**
     * The `updatedAt` of the version the operator edited. A different current value means another operator saved in between: the edit is refused with 409 rather than overwriting theirs.
     * @type {string}
     * @memberof UpdateCannedResponseDto
     */
    'expectedUpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCannedResponseDto
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCannedResponseDto
     */
    'bodyDe'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCannedResponseDto
     */
    'bodyEn'?: string;
    /**
     * Null clears the category (= fits any ticket). Omit to leave it unchanged.
     * @type {string}
     * @memberof UpdateCannedResponseDto
     */
    'category'?: UpdateCannedResponseDtoCategoryEnum | null;
}

/**
    * @export
    * @enum {string}
    */
export enum UpdateCannedResponseDtoCategoryEnum {
    Question = 'QUESTION',
    Bug = 'BUG',
    FeatureRequest = 'FEATURE_REQUEST',
    Feedback = 'FEEDBACK',
    Billing = 'BILLING',
    TaxCompliance = 'TAX_COMPLIANCE',
    DataExport = 'DATA_EXPORT',
    Onboarding = 'ONBOARDING',
    Other = 'OTHER'
}


